// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__oWLhV","emails":"CreateEditClinics_emails__YgAlz","emailTagLabel":"CreateEditClinics_emailTagLabel__2W3td"};